package co.maytes.standupbot.dashboard.features.settings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.components.feedback.Modal
import co.maytes.standupbot.dashboard.components.feedback.ModalSize
import co.maytes.standupbot.dashboard.components.widgets.Button
import co.maytes.standupbot.dashboard.components.widgets.ButtonVariant
import co.maytes.standupbot.dashboard.features.roster.LinearUserSelect
import co.maytes.standupbot.dashboard.features.roster.LinearUsersState
import co.maytes.standupbot.dashboard.features.roster.rememberLinearUsersStore
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.coroutines.launch

@Composable
fun LinkLinearIdentityModal(
    displayName: String,
    currentLinearUserId: String?,
    onSave: (linearUserId: String?) -> Unit,
    onDismiss: () -> Unit,
    hintEmail: String? = null,
) {
    val auth = rememberAuthStore()
    val store = rememberLinearUsersStore()
    val scope = rememberCoroutineScope()
    val workspaceId = auth.currentUser?.workspace?.id
    var picked by remember { mutableStateOf(currentLinearUserId) }

    LaunchedEffect(workspaceId) {
        workspaceId?.let { store.loadOnce(it) }
    }

    val state = store.state
    val currentUser = (state as? LinearUsersState.Ready)?.users?.firstOrNull { it.id == currentLinearUserId }
    val unchanged = picked == currentLinearUserId

    Modal(
        onDismiss = onDismiss,
        title = "Link Linear identity",
        size = ModalSize.Md,
        footer = {
            if (currentLinearUserId != null) {
                Button(label = "Unlink", variant = ButtonVariant.Ghost, onClick = { onSave(null) })
            }
            SpanText(text = "", modifier = Modifier.styleModifier { property("flex", "1 1 auto") })
            Button(label = "Cancel", variant = ButtonVariant.Ghost, onClick = onDismiss)
            Button(
                label = "Save",
                variant = ButtonVariant.Primary,
                enabled = picked != null && !unchanged,
                onClick = { onSave(picked) },
            )
        },
    ) {
        SpanText(
            text = "Pick the Linear person for $displayName. Their standup will then pull from Linear activity " +
                "assigned to them, across every standup they're a member of.",
            modifier = Modifier
                .fontSize(Typography.bodySmall.size)
                .color(Palette.textSecondary)
                .margin(bottom = Spacing.md),
        )
        if (currentLinearUserId != null) {
            SpanText(
                text = "Currently linked to " +
                    (currentUser?.let { "${it.name}${it.email?.let { mail -> " ($mail)" }.orEmpty()}" } ?: "a Linear person not in this list") +
                    ".",
                modifier = Modifier
                    .fontSize(Typography.bodySmall.size)
                    .color(Palette.textSecondary)
                    .margin(bottom = Spacing.sm),
            )
        }
        LinearUserSelect(
            state = state,
            hintName = displayName,
            hintEmail = hintEmail,
            selectedId = picked,
            onSelect = { picked = it.id },
            onRetry = { workspaceId?.let { scope.launch { store.reload(it) } } },
        )
    }
}
